import { usePrismicDocuments } from '@emico/prismic'

import TextFilter from './TextFilter'
import VisualFilter from './VisualFilter'
import { VisualFilter as VisualFilterType } from '../../graphql/schema.generated'

const CategoryFilter = ({ id }: { id: number }) => {
    // There is no way to filter on multiple predicates
    // So we fetch all the data by tag, and filter afterwards
    const { data, loading } = usePrismicDocuments<VisualFilterType>({
        key: 'document.tags',
        values: [id.toString()],
    })

    if (loading) {
        return null
    }

    // filter data for visual filters as there could be other types that have the same category id tag assigned
    const visualFilterData = data?.filter(
        (item) => item.data.__typename === 'VisualFilter',
    )

    if (!visualFilterData || visualFilterData.length === 0) {
        return <TextFilter id={id} />
    }

    const cards = visualFilterData[0]?.data.cards ?? []

    if (cards.length === 0) {
        return <TextFilter id={id} />
    }

    const items = cards.filter(
        ({ image, relativeUrl, title }) =>
            image && image.url && relativeUrl && title,
    )

    return items && items.length > 0 ? (
        <VisualFilter items={items} />
    ) : (
        <TextFilter id={id} />
    )
}

export default CategoryFilter
